module.exports = __webpack_public_path__ + "static/Apercu-BoldItalic-e3a22182ced03b7cf785618e49e644b8.svg";